<template>
  <div class="consent-item" :class="{ '-is-error': hasError }">
    <template v-if="isRadio">
      <div class="consent-item-content">
        <div class="consent-item-title">
          {{ consent.title }}
        </div>

        <div
          v-if="consent.description"
          class="consent-item-desc html-content -small"
          v-html="consent.description"
        ></div>
      </div>

      <v-radio-group
        :value="answer"
        :name="`consent-${consent.key}`"
        :error-messages="errorMessage"
        :hide-details="!hasError"
        row
        class="consent-item-radio mt-0 pt-0"
        @change="onChange"
      >
        <v-radio
          v-for="option in choiceOptions"
          :key="`${consent.key}-${option.label}`"
          :value="option.value"
          :label="option.label"
          color="primary"
          :ripple="false"
        />
      </v-radio-group>
    </template>

    <template v-else>
      <v-checkbox
        :input-value="answer === true"
        :true-value="true"
        :false-value="false"
        :error-messages="errorMessage"
        :hide-details="!hasError"
        color="primary"
        :ripple="false"
        class="consent-item-checkbox mt-0 pt-0"
        @change="onChange"
      >
        <template v-slot:label>
          <span class="consent-item-title">
            {{ consent.title }}
          </span>
        </template>
      </v-checkbox>

      <div
        v-if="consent.description"
        class="consent-item-desc html-content -small"
        v-html="consent.description"
      ></div>
    </template>
  </div>
</template>

<script>
import {
  CONSENT_CHOICE_OPTIONS,
  CONSENT_ERROR_MESSAGE,
  CONSENT_ERROR_REASON,
  CONSENT_INPUT_TYPE,
  CONSENT_REQUIREMENT,
} from '@/config/consent'

export default {
  name: 'BaseCampaignConsentItem',

  props: {
    consent: {
      type: Object,
      required: true,
    },
    answer: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    serverReason: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      choiceOptions: CONSENT_CHOICE_OPTIONS,
    }
  },

  computed: {
    isRadio() {
      return this.consent.input_type === CONSENT_INPUT_TYPE.RADIO
    },

    acceptLabel() {
      return CONSENT_CHOICE_OPTIONS[0].label
    },

    hasError() {
      return !!this.serverReason || this.error
    },

    errorMessage() {
      if (!this.hasError) {
        return ''
      }

      if (
        this.serverReason === CONSENT_ERROR_REASON.NOT_ACCEPTED ||
        this.consent.requirement === CONSENT_REQUIREMENT.MUST_ACCEPT
      ) {
        return CONSENT_ERROR_MESSAGE.NOT_ACCEPTED
      }

      return this.isRadio
        ? CONSENT_ERROR_MESSAGE.MISSING_RADIO
        : CONSENT_ERROR_MESSAGE.MISSING_CHECKBOX
    },
  },

  methods: {
    onChange(value) {
      this.$emit('change', {
        key: this.consent.key,
        value: value ?? false,
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.consent-item
  display: flex
  flex-direction: column
  gap: 8px

.consent-item-content
  display: flex
  flex-direction: column
  gap: 4px

.consent-item-title
  font-size: 14px
  font-weight: 600
  color: rgba(#000000, 0.85)

.consent-item-desc
  color: rgba(#000000, 0.65)

  ::v-deep a
    text-decoration: underline

.consent-item-radio
  ::v-deep .v-input--radio-group__input
    gap: 24px

  ::v-deep .v-radio
    margin-right: 0 !important
</style>
